import Title from "components/Title";

export default function NotFound() {
  return <Title titulo="Página não encontrada!" />;
}